import {isEmpty} from 'lodash';
import useFeatureFlags from 'src/hooks/useFeatureFlags';
import useUserType from 'src/hooks/use-user-type/use-user-type';

const useLeadGenerationLogoFlag = (): boolean | null => {
  const {isCollegePortalUser} = useUserType();
  const flags = useFeatureFlags(isCollegePortalUser ? ['leadGenerationLogoFlag'] : []);

  if (!isCollegePortalUser) {
    return false;
  }

  if (isEmpty(flags)) {
    return null;
  }

  return Boolean(flags.leadGenerationLogoFlag);
};

const useBrandName = (): string | null => {
  const leadGenerationLogoFlag = useLeadGenerationLogoFlag();

  if (leadGenerationLogoFlag === null) {
    return null;
  }

  return leadGenerationLogoFlag ? 'Lead Generation' : 'Raise Me';
};

// Mirrors PartnerDataService#lead_generation_students_key on the backend so the
// accessor used to read chart/table/CSV data always matches the key the API returns.
export const useLeadGenerationStudentsAccessor = ():
  | 'leadGenerationStudents'
  | 'raiseStudents'
  | null => {
  const leadGenerationLogoFlag = useLeadGenerationLogoFlag();

  if (leadGenerationLogoFlag === null) {
    return null;
  }

  return leadGenerationLogoFlag ? 'leadGenerationStudents' : 'raiseStudents';
};

export default useBrandName;
